module.exports = __webpack_public_path__ + "img/no_photo.8759007b.jpg";